/** zh-CN catalogue `shell` (W3-09; English: src/app/shell/shell.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const REGION_IN =
  '{region, select, lane {音符轨道} motion {运动列} curve {曲线编辑器} preview {预览} lines {判定线面板} inspector {属性面板} timing {曲目与时间} dock {停靠面板} problems {问题} history {历史} assets {素材} raw {原始数据面板} publish {发布} library {谱面库} settings {设置} other {{region}}}';

const catalog: MessageCatalog = {
  ns: 'shell',
  locale: 'zh-CN',
  messages: {
    wsTiming: '曲目与时间',
    wsTimingShort: '时间',
    wsChart: '谱面',
    wsPublish: '发布',
    wsLibrary: '谱面库',
    wsSettings: '设置',
    layoutCompose: '编排',
    layoutComposeDetail: '音符轨道和运动列，大预览，面板位于其下方。',
    layoutAnimate: '动画',
    layoutAnimateDetail: '给运动列更多空间；预览较小。',
    layoutReview: '审阅',
    layoutReviewDetail: '最大的预览，并打开“问题”选项卡。',
    layoutLaptop: '笔记本',
    layoutLaptopDetail: '适用于小屏幕：预览浮动显示，面板移入侧边抽屉。',
    layoutAuto: '笔记本布局（在此屏幕尺寸下自动应用）',
    cmdPalette: '命令面板',
    cmdWorkspace: '切换工作区',
    cmdCloseProject: '关闭项目',
    cmdLibrary: '前往谱面库',
    cmdUndo: '撤销',
    cmdRedo: '重做',
    cmdZoomIn: '放大时间',
    cmdZoomOut: '缩小时间',
    cmdResetView: '重置时间轴视图',
    cmdResetLanePan: '将音符轨道居中（重置 X 平移）',
    cmdFrameSelection: '使选中内容充满视图',
    cmdMotionColumns: '显示运动列',
    cmdWaveform: '显示波形',
    cmdFollowPlayhead: '跟随播放头',
    cmdLayout: '布局',
    cmdMiniPreview: '迷你预览窗口',
    cmdDrawer: '侧边抽屉',
    cmdPlayPause: '播放 / 暂停',
    cmdPlayFromStart: '从谱面开头播放',
    cmdHoldReturn: '按住时播放，松开后返回',
    cmdHoldStay: '按住时播放，松开后停留',
    cmdStopReturn: '停止并返回播放开始处',
    cmdStopStay: '在此停止',
    cmdPlayMaximized: '最大化预览并播放',
    cmdReturnOnStop: '停止时返回起始点',
    cmdRateDown: '降低播放速度',
    cmdRateUp: '提高播放速度',
    cmdSetRate: '播放速度',
    cmdMetronome: '节拍器',
    cmdLoop: '循环播放',
    cmdSeekForward: '前进一个吸附步长',
    cmdSeekBack: '后退一个吸附步长',
    cmdSeekBarForward: '前进一个小节',
    cmdSeekBarBack: '后退一个小节',
    cmdSeekStart: '转到谱面开头',
    cmdSeekEnd: '转到谱面结尾',
    cmdSeekSelStart: '转到选中内容的开头',
    cmdSeekSelEnd: '转到选中内容的结尾',
    cmdSeekSeconds: '按秒移动播放头',
    cmdSnapPlayhead: '将播放头吸附到网格',
    cmdSnapDiv: '设置节拍吸附',
    cmdSnapFiner: '更细的节拍吸附',
    cmdSnapCoarser: '更粗的节拍吸附',
    cmdSnapBeat: '吸附到节拍网格',
    cmdSnapX: '吸附到 X 网格',
    cmdSnapXGrid: '设置 X 网格线数量',
    cmdGoto: '转到拍数、时间或标记',
    cmdReveal: '在时间轴中显示某个位置',
    cmdPrevKey: '上一个关键帧',
    cmdNextKey: '下一个关键帧',
    cmdPrevNote: '当前判定线上的上一个音符',
    cmdNextNote: '当前判定线上的下一个音符',
    cmdHelpPalette: '搜索帮助主题',
    cmdCheatSheet: '快捷键',
    argWorkspace: '工作区',
    argLayout: '布局',
    argRate: '播放速度',
    argSeconds: '秒数（负数为后退）',
    argSnapDiv: '将每拍分为（1 到 1920）',
    argXGrid: 'X 网格线（1 到 1000）',
    rateOption: '{rate}x',
    argAnyProperty: '任意有动画的属性',
    argSecondsValue: '{sec, number, 0.0##} 秒',
    reasonNoProject: '请先打开一张谱面。',
    reasonNothingToUndo: '没有可撤销的操作。',
    reasonNothingToRedo: '没有可重做的操作。',
    reasonGestureActive: '请先完成或取消当前的拖动。',
    reasonNoSelection: '请先选中音符或关键帧。',
    reasonNoFocusedColumn: '请先单击一个运动列或选择一条判定线。',
    reasonNoActiveLine: '请先选择一条判定线。',
    reasonLaptopOnly: '仅用于笔记本布局（小屏幕）。',
    reasonGuidedDocked: '在引导模式下，预览始终保持在视野中。',
    reasonNarrowDocked: '在窄屏幕上，预览会停靠在音符轨道旁边。',
    reasonNotHere: '此处不可用。',
    reasonUnknownCommand: '此命令不属于当前版本。',
    toastUndid: '已撤销：{label}',
    toastRedid: '已重做：{label}',
    toastTip: '提示：“{command}”也有快捷键：{keys}',
    toastDialogUnavailable: '此版本中还没有这个窗口。',
    toastNoNoteBefore: '此判定线上没有更早的音符。',
    toastNoNoteAfter: '此判定线上没有更晚的音符。',
    toastNoKeyBefore: '没有更早的关键帧。',
    toastNoKeyAfter: '没有更晚的关键帧。',
    toastError: '出现了问题：{error}',
    toastDropNone: 'Phiedit 无法打开{count, plural, =1 {此文件} other {这些文件}}。',
    toastDropFailed: '无法打开拖入的文件：{error}',
    toastDropEmpty: '拖入的文件夹中没有可打开的文件。',
    toastDropTruncated: '拖入的文件夹中文件太多；只读取了前 {count} 个。',
    toastRecoveryFailed: '无法读取恢复数据：{error}',
    toastProtected: '你的谱面现在不会被自动清理了。',
    toastProtectRefused: '浏览器不允许这样做。请不时下载备份以确保安全。',
    toastCopied: '已复制到剪贴板。',
    toastsLabel: '通知',
    toastUndo: '撤销',
    toastDismiss: '关闭',
    toastCount: 'x{count}',
    toastKind: '{kind, select, success {完成} warning {警告} error {错误} other {提示}}',
    labelValue: '{label}：{value}',
    argParen: '{label}（{value}）',
    withArgs: '{title}…',
    orJoin: '{a} / {b}',
    listJoin: '{a}、{b}',
    projectMenuLabel: '项目菜单：{name}{level, select, none {} other {（{level}）}}',
    reportComponentStack: '组件栈：',
    reportUrl: '地址：{url}',
    reportBrowser: '浏览器：{agent}',
    reportTime: '时间：{time}',
    topBarLabel: '编辑器工具栏',
    workspacesLabel: '工作区',
    overflow: '更多',
    overflowAttention: '更多（有需要你注意的内容）',
    paletteButton: '搜索命令',
    undoWith: '撤销：{label}',
    redoWith: '重做：{label}',
    projectMenu: '项目菜单',
    untitled: '未命名谱面',
    menuEdit: '编辑',
    menuView: '视图',
    menuHelp: '帮助',
    menuSnap: '吸附',
    transportLabel: '播放',
    play: '播放',
    pause: '暂停',
    timeReadout: '播放头位于第 {beat} 拍，{time}。单击可输入位置。',
    timeInputLabel: '转到拍数或时间',
    timeInputPlaceholder: '12:1/4、23.5s 或 m1',
    timeInvalid: '此输入框无法识别该拍数或时间。',
    rateLabel: '播放速度 {rate}x',
    rateStreaming: '降速播放会保持音高；时间会略不精确。',
    snapLabel: '吸附',
    snapDivLabel: '节拍吸附',
    snapDivValue: '1/{div}',
    snapDivTriplet: '1/{div}（三连音）',
    snapCustomLabel: '将每拍分为',
    snapApply: '应用',
    xGridLabel: 'X 网格线',
    xGridValue: 'X {n}',
    saveSaved: '已保存',
    saveSaving: '正在保存…',
    saveError: '未保存',
    saveErrorFull: '未保存：存储空间已满',
    saveReconnecting: '正在重新连接存储…',
    saveAtRisk: '{risk, select, lowSpace {有风险：存储空间即将用尽} other {有风险：未受保护}}',
    saveDetailsTitle: '保存',
    saveLastSaved: '上次保存于 {time}。',
    saveNeverSaved: '本次会话中还没有保存任何内容。',
    savePending: '有 {count, plural, other {# 项更改}}等待写入。',
    saveUsage: '已使用浏览器存储 {used}，共 {quota}（剩余 {free}）。',
    saveProtected: '已防止被自动清理。',
    saveNotProtected: '未受保护：空间不足时浏览器可能会删除谱面。',
    saveWriteError: '上次写入失败：{error}',
    protectCharts: '保护我的谱面',
    downloadRecovery: '下载恢复数据',
    downloadBackup: '立即下载备份',
    problemsChip:
      '{fatal, plural, =0 {} other {# 个致命问题，}}{errors, plural, other {# 个错误}}，{warnings, plural, other {# 个警告}}{tips, plural, =0 {} other {，# 条提示}}。单击以显示。',
    problemsNone: '未发现问题。单击以打开“问题”。',
    levelLabel: '经验模式：{level, select, guided {引导} other {完整}}',
    levelGuided: '引导',
    levelGuidedDetail: '一次显示的工具更少，提示通俗易懂。',
    levelFull: '完整',
    levelFullDetail: '所有工具和属性。',
    exportChanged: '上次导出（{when}）后有更改。单击以导出。',
    exportNever: '尚未导出。单击以导出。',
    exportChip: '导出后有更改',
    bytes: '{n, number, 0.#} {unit, select, kb {KB} mb {MB} gb {GB} other {B}}',
    timeAgoNow: '刚刚',
    timeAgoMinutes: '{n, plural, other {# 分钟}}前',
    timeAgoHours: '{n, plural, other {# 小时}}前',
    timeAgoDays: '{n, plural, other {# 天}}前',
    bannersLabel: '通知',
    bannerWriteError: '更改没有被保存：{error}',
    bannerQuota:
      '浏览器存储空间即将用尽：剩余 {free}（已使用 {used}，共 {quota}）。请立即下载备份；删除旧谱面或版本可以释放空间。',
    bannerNotPersisted: '空间不足时浏览器可能会删除谱面。请不时下载备份以确保安全。',
    bannerExportStale: '此谱面在上次导出（{when}）后有更改。请导出一份副本，以便在浏览器之外安全保存。',
    bannerExportNever: '此谱面创建于{when}，从未导出过。请导出一份副本，以便在浏览器之外安全保存。',
    exportNow: '导出…',
    bannerReconnecting: '正在重新连接存储。你的编辑已保留，连接恢复后会立即写入。',
    dismiss: '关闭',
    hintBarLabel: '提示',
    hintIn: '{where}：',
    hintRegion:
      '{region, select, lane {音符轨道} motion {运动列} curve {曲线编辑器} preview {预览} lines {判定线} inspector {属性面板} timing {曲目与时间} dock {停靠面板} problems {问题} history {历史} assets {素材} raw {原始数据} publish {发布} library {谱面库} settings {设置} other {编辑器}}',
    hintTool:
      '{tool, select, select {选择工具} tap {Tap 工具} drag {Drag 工具} flick {Flick 工具} hold {Hold 工具} eraser {橡皮擦工具} other {{tool}}}',
    hintGestureItem: '{keys} {label}',
    hintFocusedColumn:
      '关键帧将添加到 {line} 的{prop, select, moveX {X 位置} moveY {Y 位置} rotate {旋转} alpha {不透明度} speed {流速} scaleX {X 缩放} scaleY {Y 缩放} color {颜色} text {文字} incline {倾斜} paint {绘制} gif {GIF 进度} other {{prop}}}{layer, plural, =0 {} other {（层级 #）}}。',
    hintNoProject: '打开一张谱面或新建一张。',
    hintCheatSheet: '快捷键',
    paletteLabel: '命令面板',
    palettePlaceholder: '输入命令，或 # 判定线、@ 时间、? 帮助、: 设置',
    palettePlaceholderLines: '判定线编号或名称',
    palettePlaceholderTime: '拍数（12:1/4）、时间（1:23.5）或标记名称',
    palettePlaceholderHelp: '搜索帮助主题和术语表',
    palettePlaceholderSettings: '搜索设置',
    palettePlaceholderQuery: '按查询条件选择',
    paletteEmpty: '没有匹配项。',
    paletteNothingYet: '此版本中这里还没有可搜索的内容。',
    paletteLoading: '正在搜索…',
    paletteRecent: '最近使用',
    paletteCommands: '命令',
    paletteResults: '结果',
    paletteNotHereGroup: '此处不可用',
    paletteFullTag: '完整',
    paletteFullTagHint: '完整模式的命令：可以运行一次，或切换到完整模式。',
    palettePrefixes: '前缀',
    prefixCommands: '命令',
    prefixLines: '判定线',
    prefixTime: '时间或标记',
    prefixQuery: '查询',
    prefixHelp: '帮助',
    prefixSettings: '设置',
    paletteArgBack: '返回命令',
    paletteArgHint: 'Enter 运行，Esc 返回。',
    paletteArgNumber: '请输入 {min} 到 {max} 之间的数字。',
    paletteArgNumberAny: '请输入一个数字。',
    paletteArgBeatInvalid: '此输入框无法识别该拍数。',
    paletteArgBeatEcho: '= {beat}',
    paletteArgNoLines: '请打开一张谱面以选择判定线。',
    paletteArgLine: '判定线 {index}：{name}',
    paletteArgUnnamedLine: '判定线 {index}',
    paletteGotoBeat: '转到第 {beat} 拍',
    paletteGotoRelative: '将播放头移到第 {beat} 拍',
    paletteGotoTime: '转到 {time}',
    paletteGotoDetail: '{beat} · {time}',
    paletteMarker: '标记：{name}',
    category:
      '{category, select, File {文件} Edit {编辑} Select {选择} View {视图} Playback {播放} Notes {音符} Motion {运动} Lines {判定线} Timing {时间} Tools {工具} Publish {发布} Help {帮助} other {{category}}}',
    cheatTitle: '快捷键',
    cheatPreset: '{preset, select, rpe {RPE 键位} other {默认键位}}{altFree, select, yes {，免 Alt} other {}}',
    cheatSearch: '搜索快捷键',
    cheatPrint: '打印',
    cheatEmpty: '没有匹配的快捷键。',
    cheatActiveNow: '当前可用',
    cheatEverywhere: '所有位置',
    cheatEdit: '修改快捷键',
    cheatNot: '非“{what}”',
    cheatNone:
      '{atom, select, sel_notes {未选中音符} sel_keys {未选中关键帧} sel_segments {未选中区段} sel_lines {未选中判定线} sel_bpm {未选中速度点} sel_any {未选中任何内容} sel_single {不是单个选中项} sel_mixed {不是混合选中} other {非 {name}}}',
    cheatJoin: '{a}，{b}',
    atom: '{atom, select, textInput {正在输入框中输入} dialog {在对话框中} paletteOpen {命令面板已打开} placing_hold {正在放置 Hold} placing_segment {正在放置区段} paste_ghost {正在粘贴} gesture {正在拖动} playing {正在播放} sel_notes {已选中音符} sel_keys {已选中关键帧} sel_segments {已选中区段} sel_lines {已选中判定线} sel_bpm {已选中速度点} sel_any {已选中内容} sel_single {已选中一项} sel_mixed {已选中不同类型的内容} column_focused {已聚焦运动列} project_open {已打开谱面} activeLine_uiMover {当前为 UI 绑定线} activeLine_notesAllowed {当前判定线可放置音符} testPlay {正在试玩} theater {在影院模式中} batch_sheetOpen {已打开工具面板} problems_fixing {正在修复问题} curve_expanded {曲线编辑器已打开} markers_selected {已选中标记} tour_active {导览进行中} help_focused {在帮助面板中} timing_overviewHover {指针位于曲目总览上} other {{name} 适用时}}',
    atomRegion: `{prefix, select, hover {指针位于} other {焦点位于}}${REGION_IN}`,
    atomCompare:
      '{name, select, workspace {工作区} level {模式} preset {键位预设} tool {工具} os {系统} other {{name}}}{op, select, ne {不是} other {是}} {value}',
    contextMenuLabel: '右键菜单',
    dialogCancel: '取消',
    dialogCrashed: '此窗口停止工作，已被关闭。',
    chooseHint: '选择一项',
    popoverLabel: '弹出框',
    crashTitle: '出现了问题',
    crashBody: 'Phiedit 遇到了意外错误。你的谱面已保存到最后一次更改；重新加载页面通常可以解决此问题。',
    crashReload: '重新加载',
    crashLibrary: '前往谱面库',
    crashDownload: '下载恢复数据',
    crashCopy: '复制错误详情',
    crashDetails: '错误详情',
    panelCrashTitle: '此面板停止工作',
    panelCrashBody: '编辑器的其余部分仍可使用。重新加载面板通常可以解决此问题。',
    panelRetry: '重新加载面板',
    bootFailedTitle: 'Phiedit 无法启动',
    bootFailedBody: '启动时需要的某项内容失败了：{error}',
    slotEmptyTitle: '这里还没有内容',
    slotEmpty:
      '{slot, select, chart_preview {谱面的预览会显示在这里。} chart_timeline {音符轨道和运动列会显示在这里。} chart_inspector {选中内容后，其属性会显示在这里。} chart_dock {判定线、问题和历史会显示在这里。} chart_tools {工具会显示在这里。} timing_left {速度和曲目偏移会显示在这里。} timing_main {曲目总览会显示在这里。} timing_bottom {对齐工具会显示在这里。} publish_left {谱面检查会显示在这里。} publish_right {打包和导出会显示在这里。} other {此版本中编辑器的这一部分还不可用。}}',
    slotLabel:
      '{slot, select, chart_tools {工具} chart_timeline {时间轴} chart_preview {预览} chart_dock {停靠面板} chart_inspector {属性面板} timing_left {速度与偏移} timing_main {曲目总览} timing_bottom {对齐} publish_left {检查} publish_right {打包与导出} topbar_left {项目工具} topbar_center {播放工具} topbar_right {状态} statusbar {状态栏} other {面板}}',
    sectionToggle: '{open, select, yes {收起} other {展开}}{title}',
    miniPreviewTitle: '预览',
    miniPreviewHide: '隐藏预览',
    miniPreviewMove: '拖动以移动预览',
    drawerTitle: '面板',
    drawerClose: '关闭抽屉',
    motionDrawerTitle: '运动',
    motionDrawerLabel: '运动列（底部抽屉）',
    workspaceLabel: '{workspace, select, timing {曲目与时间} publish {发布} other {谱面}}工作区',
    editorLabel: '谱面编辑器',
    opening: '正在打开谱面…',
    openFailedTitle: '无法打开谱面',
    openFailedBody: '{error}',
    backToLibrary: '返回谱面库',
    retry: '重试',
    notFoundTitle: '找不到页面',
    notFoundBody: '地址 {hash} 在 Phiedit 中没有对应的页面。',
    libraryUnavailableTitle: '此版本中还没有谱面库',
    libraryUnavailableBody: '谱面可以通过链接打开；设置仍然可以访问。',
    openSettings: '设置',
    dropTitle: '拖放以打开',
    dropBody: '曲目、谱面、谱面包（.pez、.zip）、皮肤和图片',
    unknownError: '未知错误',
    argMs: '{n} 毫秒',
    argQuick: '不打开对话框',
    argSteps: '{n, plural, other {# 步}}',
    cheatMouse: '鼠标和触控板',
    cheatSituations: '{a}；{b}',
    gestureAltWheel: '更改节拍吸附',
    gestureAltWheelRpe: '更快地滚动时间轴',
    gestureCtrlShiftWheel: '横向缩放指针下方的列',
    gestureCtrlWheel: '以指针为中心缩放时间（触控板双指缩放也可以）',
    gestureCtrlWheelRpe: '微调指针下方的内容：选中音符的宽度、关键帧的数值（触控板双指缩放用于缩放时间）',
    gestureMiddleDrag: '平移时间轴',
    gestureMiddleDragKeys: '中键拖动',
    gestureShiftWheel: '更快地滚动时间轴（Mac 上不可用）',
    gestureWheel: '滚动时间轴',
    hintToolUse:
      '{tool, select, tap {在音符轨道中单击以放置 Tap。} drag {在音符轨道中单击以放置 Drag。} flick {在音符轨道中单击以放置 Flick。} hold {在音符轨道中向上拖动以绘制 Hold。} eraser {单击音符将其擦除，或拖过多个音符。} other {}}',
    noticeCount: '{index} / {count}',
    noticeLater: '稍后',
    noticeLaterDetail: '暂时隐藏此通知。编辑约两小时后会再次出现。',
    noticeNext: '下一条通知（{index} / {count}）',
    problemsChecking: '正在检查谱面。第一次检查完成后问题会立即显示。单击以打开“问题”。',
    problemsCheckingShort: '正在检查…',
    readoutApprox: '~{beat}',
    readoutExact: '精确值 {beat}（读数中已取整到吸附步长）',
    matrixTitle: '键盘检查',
    matrixIntro:
      '每当显示一个快捷键时就按下它。页面会记录此浏览器和操作系统是否让它通过，以及浏览器是否阻止了自身的默认操作。有些快捷键会关闭或切换窗口；请回到此标签页继续。下载结果并附到检查清单中。',
    matrixStart: '开始',
    matrixContinue: '继续',
    matrixSkip: '跳过此项',
    matrixRestart: '重新开始',
    matrixCopy: '复制结果',
    matrixDownload: '下载结果',
    matrixCopied: '结果已复制到剪贴板。',
    matrixCopyFailed: '浏览器不允许复制。请改为下载结果。',
    matrixProgress: '已尝试 {done} 个，共 {total} 个',
    matrixPress: '现在请按：',
    matrixWaiting: '如果 {sec} 秒内没有任何反应，则视为未能通过。',
    matrixDone: '所有快捷键都已尝试。请下载结果。',
    matrixColChord: '快捷键',
    matrixColFrom: '绑定于',
    matrixColCommands: '命令',
    matrixColResult: '结果',
    matrixSource:
      '{source, select, default {默认键位} rpe {RPE 键位} altLetter {Alt + 字母} reserved {保留} reservedMac {在 macOS 上保留} other {{source}}}',
    matrixResult:
      '{result, select, works {有效} missing {未能通过} kept {浏览器也会响应} blurred {窗口失去焦点} untested {尚未尝试} other {{result}}}',
    matrixFlags: '标记',
    matrixUnreliable: '列为不可靠',
    matrixReserved: '保留',
    matrixLabel: '键盘检查结果',
  },
};

export default catalog;
